import React, { useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import './style.css'

const InputSearch = (props) => {
    const navigate = useNavigate();
    const [search, setSearch] = useState('')
    const [textSearch, setTextSearch] = useState('')

    const handleSearch = (e) => {
        setTextSearch(e.target.value)
        props.handleChangeValueInputSearch(e.target.value)

        // if (e.keyCode != 13) {
        //     return
        // }

        // setSearch(e.target.value)
        // props.onSearchThesis(e.target.value)
    }

    const handleSearchButton = () => {
        setSearch(textSearch)
        props.onSearchThesis(textSearch)

        if (props.redirectPage) {
            navigate(`${props.redirectPage}?q=${textSearch}`);
        }
    }

    return (
        <div id='thesis-input-search' className='input-group mb-3 w-100 px-15'>
            <input type='text'
                value={props?.valueInputSearch}
                onChange={(e) => handleSearch(e)}
                className='form-control input-search'
                style={{ borderRight: 'none', borderTopLeftRadius: '5px', borderBottomLeftRadius: '5px' }}
                placeholder='Pencarian Tesis dan disertasi' />

            <div className='input-group-append p-2 bg-white w-0' style={styles.searchButton}>
                <button
                    onClick={() => handleSearchButton()}
                    className='btn btn-sm rounded-pill btn-primary text-white fw-bold'
                    type='button'>
                    <i className='bi bi-search'></i>
                    <span id='text-search'>Pencarian</span>
                </button>
            </div>
        </div>
    );
};

const styles = {
    searchButton: {
        borderRadius: '0 5px 5px 0',
        border: 'none'
    }
}

export default InputSearch;